/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useParams } from 'react-router-dom';

import LineItemForm from '../components/LineItems/LineItemForm';
import LineItemSkeleton from '../components/LineItems/LineItemSkeleton';
import useNewLineItem from '../hooks/useNewLineItem';

function NewLineItemPage() {
  const params = useParams();
  const {
    isLoading,
    data,
  } = useNewLineItem(Number(params.id));
  

  if (isLoading) {
    return <LineItemSkeleton />;
  }

  return (
    <LineItemForm isNewLineItem lineItemData={data} />
  );
}

export default NewLineItemPage;
